import { ReactNode } from 'react'
import { DataTableV2UploadFilesAction } from '../DataTableV2/types'
import { UploadFilesActionSheet } from '../DataTableV2/components/UploadFilesActionSheet'
import { CardClickTarget } from './CardClickTarget'
import { CardData } from './types'

export function CardUploadFilesAction({
  action,
  data,
  children,
}: {
  action: DataTableV2UploadFilesAction
  data: CardData
  children: ReactNode
}) {
  const namespaceParam = action.parameterMappings.namespace
  const mappedNamespace = (data as unknown as Record<string, unknown>)[namespaceParam]
  const uploadNamespace = typeof mappedNamespace === 'string' ? mappedNamespace.trim() : ''
  return (
    <UploadFilesActionSheet
      action={action}
      uploadNamespace={uploadNamespace}
      trigger={(onOpen) => (
        <CardClickTarget disabled={action.isDisabled} onClick={onOpen}>
          {children}
        </CardClickTarget>
      )}
    />
  )
}
